module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-type-skills"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.projectTypeSkills"
    }
  }), _vm._v("\n                    Hvilke svende er gode til hvilke opgaver?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder fit-content"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectEmployee
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 4229366594)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [(!_vm.selectedRow) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg en opgavetype for at se hvilke medarbejdere, der er gode til denne\n            ")]) : _c('project-type-skills-single', {
    attrs: {
      "data": _vm.selectedRow
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5949fbe8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5949fbe8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/projects/components/projectTypeSkills.vue
// module id = 840
// module chunks = 0